/**
 * One-shot "open the photo sheet" handoff: header search result 📷 → PatientPhotoAvatar.
 *
 * The header's camera shortcut navigates to a patient's profile and wants that profile's
 * photo action sheet already open, so staff tap "Take photo" next (the camera itself can only
 * open from a real tap — iOS refuses a programmatic file-input click outside a user gesture).
 *
 * WHY NOT A URL FLAG (?photo=1): Layout.vue keys <router-view> on $route.fullPath, so stripping
 * the flag afterwards remounts the whole profile, and leaving it in means a page reload pops the
 * sheet again. WHY NOT VUEX: store/patientPhoto.js is deliberately stateless.
 *
 * A request is for ONE patient and expires after PHOTO_SHEET_REQUEST_TTL_MS, so a stale one can
 * never pop the sheet later. A mismatched patient leaves it pending: the profile being navigated
 * AWAY from sees the request first and must not swallow it.
 */
import Vue from 'vue';

export const PHOTO_SHEET_REQUEST_TTL_MS = 15000;

export const photoSheetRequest = Vue.observable({ patNum: null, at: 0 });

export function clearPhotoSheetRequest() {
  photoSheetRequest.patNum = null;
  photoSheetRequest.at = 0;
}

export function requestPhotoSheet(patNum, now) {
  if (patNum == null || patNum === '') return;
  photoSheetRequest.patNum = String(patNum);
  photoSheetRequest.at = typeof now === 'number' ? now : Date.now();
}

/** True exactly once, for the patient the request was made for, while it is fresh. */
export function takePhotoSheetRequest(patNum, now) {
  if (photoSheetRequest.patNum === null) return false;
  const t = typeof now === 'number' ? now : Date.now();
  const age = t - photoSheetRequest.at;
  if (age < 0 || age > PHOTO_SHEET_REQUEST_TTL_MS) {
    clearPhotoSheetRequest();
    return false;
  }
  if (patNum == null || String(patNum) !== photoSheetRequest.patNum) return false;
  clearPhotoSheetRequest();
  return true;
}
